function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ESystemTheme } from "./useTheme";
import { commonColor, themeColors } from "../styles/colors";
import { systemDropShadows } from "../styles/dropShadow";
var memoThemeProps = {};

var createTheme = function createTheme(_ref) {
  var branding = _ref.branding,
      isSyetemThemeDark = _ref.isSyetemThemeDark,
      system = _ref.system;
  var systemColors = themeColors[system];
  var brandingColors = themeColors[branding];
  var systemDropShadow = systemDropShadows[system];
  var cacheKey = "base-".concat(system, "-").concat(branding);

  if (!memoThemeProps[cacheKey]) {
    memoThemeProps[cacheKey] = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      isSyetemThemeDark: isSyetemThemeDark
    }, commonColor), systemColors), brandingColors), brandingColors["branding_".concat(system)]), commonColor["warning_".concat(system)]), commonColor["success_".concat(system)]), commonColor["pending_".concat(system)]), systemDropShadow);
  }

  return memoThemeProps[cacheKey];
};

export function useRegisterTheme(payload) {
  var branding = payload.branding,
      custom = payload.custom,
      system = payload.system;
  var isSyetemThemeDark = system === ESystemTheme.DARK;
  var key;

  if (custom && custom.namespace) {
    key = "".concat(system, "-").concat(branding, "-").concat(custom.namespace);

    if (!memoThemeProps[key]) {
      var mergedTheme = Object.create(createTheme(_objectSpread({
        isSyetemThemeDark: isSyetemThemeDark
      }, payload)));
      var properties = custom.value ? Object.getOwnPropertyNames(custom.value) : [];
      properties.forEach(function (k) {
        var descriptor = Object.getOwnPropertyDescriptor(custom.value, k);
        Object.defineProperty(mergedTheme, k, descriptor);
      });
      memoThemeProps[key] = mergedTheme;
    }
  } else {
    key = "".concat(system, "-").concat(branding);

    if (!memoThemeProps[key]) {
      memoThemeProps[key] = createTheme(_objectSpread({
        isSyetemThemeDark: isSyetemThemeDark
      }, payload));
    }
  }

  return Object.freeze(memoThemeProps[key]);
}